<div>
    <p>
        Payment Error !!!
    </p>
    <p>
        Try again...
    </p>
</div>